import type { FC } from 'react';
import { Route } from 'react-router-dom';
import { useStorageServiceRoot } from 'src/apis/storage/use-storage-service-root';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { StorageLocationCreate } from 'src/pages/storage/locations-new/create';
import { StorageLocationDetails } from 'src/pages/storage/locations-new/details';
import { StorageLocationEdit } from 'src/pages/storage/locations-new/edit';
import { StorageLocationsOverviewNew } from 'src/pages/storage/locations-new/overview';

export const StorageLocationsNewRoot: FC = () => {
  const storageServiceRoot = useStorageServiceRoot();

  if (!storageServiceRoot.response) {
    return <PageSpinner />;
  }

  return (
    <RootRoutes>
      <Route
        path="/storage/locations"
        element={
          <StorageLocationsOverviewNew
            storageServiceRoot={storageServiceRoot}
          />
        }
      />
      <Route
        path="/storage/locations/create"
        element={
          <StorageLocationCreate storageServiceRoot={storageServiceRoot} />
        }
      />
      <Route
        path="/storage/locations/:locationId"
        element={
          <StorageLocationDetails storageServiceRoot={storageServiceRoot} />
        }
      />
      <Route
        path="/storage/locations/:locationId/edit"
        element={
          <StorageLocationEdit storageServiceRoot={storageServiceRoot} />
        }
      />

      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
